import styled from '@emotion/styled';
import { isBlank } from '@seedlang/utils';
import Spinner from 'components/spinner';
import { observer } from 'mobx-react';
import React from 'react';
import ButtonPrimary from 'components/button/button_primary';

const commonBannerStyles = `
  width: 100%;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const LiveBanner = styled.div`
  background-color: #adf;
  ${commonBannerStyles}
`;
const DirtyBanner = styled.div`
  background-color: #f7C797;
  ${commonBannerStyles}
`;
const DraftBanner = styled.div`
  background-color: #DDD;
  ${commonBannerStyles}
`;
const BannerText = styled.div`
  flex: 1;
`;
const SpinnerBanner = styled.div`
  ${commonBannerStyles}
  align-items: center;
  justify-content: center;
  min-height: 46px; // To match the height of the other banners
`;

@observer
class PodcastPublicationStateBanner extends React.Component {
  render() {
    const { publicationState } = this.props;

    if (this.props.showSpinner) {
      return (
        <SpinnerBanner>
          <Spinner margin={0} />
        </SpinnerBanner>
      );
    }

    if (isBlank(publicationState)) {
      return null;
    }

    if (publicationState === 'dirty') {
      return (
        <DirtyBanner>
          <BannerText>This podcast contains changes that require the updating of the RSS feeds.</BannerText>
          <ButtonPrimary onClick={this.props.onPublishChanges}>Publish changes</ButtonPrimary>
        </DirtyBanner>
      );
    }

    if (publicationState === 'live') {
      return (
        <LiveBanner>Live</LiveBanner>
      );
    }

    if (publicationState === 'draft') {
      return (
        <DraftBanner>Draft</DraftBanner>
      );
    }

    return (
      <DirtyBanner>Invalid state. Please contact the developers.</DirtyBanner>
    );
  }
}

export default PodcastPublicationStateBanner;